import { object, string } from 'yup'

export { provider as baseURL } from 'constants/apiBaseUrls'

export const Schema = object().shape({
  providerId: string().required(),
})

export const url = ({ providerId }) => `/v1/providers/${providerId}/payments`
